import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getOfertasPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
      queryParams.push(`aof_nombre=${encodeURIComponent(searchTerm)}`);
    }
    if (page) {
      queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  
    return await getData("/ofertascab/panel", queryString);
  }


export const getOfertaById = async (id) => {
    const res = await getData(`/ofertascab/${id}`)
    return res
}

export const postOferta = async (body) => {
    const res = await postData('/ofertascab', body)
    return res
}

export const patchOferta = async (id, body) => {
    const res = await patchData(`/ofertascab/${id}`, body)
    return res
}

export const deleteOferta= async (id) => {
    const res = await deleteData(`/ofertascab/${id}`)
    return res
}


